import { CommonModule, Location } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroStar } from '@ng-icons/heroicons/outline'
import { KENDO_BUTTON, KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons'
import { WindowRef } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNLIST, KENDO_MULTISELECT } from '@progress/kendo-angular-dropdowns'
import { KENDO_ICON } from '@progress/kendo-angular-icons'
import { KENDO_INPUTS, KENDO_MASKEDTEXTBOX } from '@progress/kendo-angular-inputs'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { interval } from 'rxjs'
import { NgxValidationMessageComponent } from '../../../@components/validation-message/validation-message.component'
import { UserStateService } from '../../@theme/services/user-state.service'
import { UserService } from '../../@theme/services/user.service'
import { UserInfo } from '../../models/userModels'
import { AuthservicesService } from '../services/authservices.service'

@Component({
  selector: 'gd--register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  providers: [WindowRef, provideIcons({ heroStar })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    KENDO_BUTTON,
    KENDO_ICON,
    KENDO_MASKEDTEXTBOX,
    KENDO_DROPDOWNLIST,
    KENDO_MULTISELECT,
    FormsModule,
    ReactiveFormsModule,
    LabelDirective,
    KENDO_INPUTS,
/*     NgxValidationMessageComponent, */
    KENDO_DROPDOWNBUTTON,
  ]
})
export class NgxRegisterComponent implements OnInit, AfterViewInit {
  submitted = false
  showMessages: any
  firstname: string
  roles$: [] = []
  public mySelectionroleLinks: any[] = []
  errors: string[] = []
  messages: string[] = []
  user: any = {}
  registerForm: UntypedFormGroup
  constructor(
    protected cd: ChangeDetectorRef,
    public fb: UntypedFormBuilder,
    protected router: Router,
    private ur: UserService,
    private auth: AuthservicesService,
    private toastrService: ToastrService,
    private stateService: UserStateService,
    private location: Location,
  ) {
    this.registerForm = fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      username: ['', Validators.required],
      phonenumber: [''],
      roles: [''],
      branchlist: [],
      email: new UntypedFormControl(
        '',
        Validators.compose([Validators.required]),
      ),
    })
  }
  get f() {
    return this.registerForm.controls
  }
  ngAfterViewInit(): void {
    this.ur.getRoleList().subscribe((response) => {
      this.roles$ = response.filter(
        (x) =>
          x.name !== 'REP' &&
          x.name !== 'BRANCH ACCESS NON MANAGER' &&
          x.name !== 'BRANCH MANAGER' &&
          x.name !== 'SUPERUSER',
      )
    })
    this.mySelectionroleLinks = [] // ['da80df6a-50bd-482c-a3ee-d2232112811a']
    this.cd.detectChanges()
  }
  ngOnInit(): void {
    if (
      this.stateService.currentUserInfo &&
      this.stateService.currentUserInfo.email
    ) {
      const observable1 = interval(300)
      const observable2 = interval(200)

      const subscription = observable1.subscribe(() => this.getformfields())
      const childSubscription = observable2.subscribe(() =>
        this.getexistingrepifExists(),
      )
      subscription.add(childSubscription)
      setTimeout(() => {
        subscription.unsubscribe()
      }, 1000)
    }
  }
  getformfields(): void {
    const params = {
      email: this.stateService.currentUserInfo.email,
      RememberUser: false
    }
    this.auth
      .getUserByEmail(params)
      .subscribe((response) => {
        if (response) {
          this.stateService.currentUserInfo = new UserInfo(response)
        }
        const editUser = this.stateService.currentUserInfo
        this.registerForm.controls['firstname'].setValue(editUser.firstName)
        this.registerForm.controls['lastname'].setValue(editUser.lastName)
        this.registerForm.controls['username'].setValue(editUser.username)
        this.registerForm.controls['phonenumber'].setValue(editUser.phoneNumber)
        this.registerForm.controls['roles'].setValue(editUser.roles)
        this.registerForm.controls['email'].setValue(editUser.email)
        this.stateService.currentUserInfo = null
      })
  }
  getexistingrepifExists(): void {
    const editUser = this.stateService.currentUserInfo
    this.registerForm.controls['roles'].setValue(editUser.roles)
  }
  register(): void {
    this.user = this.registerForm.value
    this.errors = this.messages = []
    this.submitted = true
    //    alert(JSON.stringify(this.user))
    this.auth.register(this.user).subscribe((result: UserInfo) => {
      if (result) {
        this.showToast(
          'success',
          'You have successfully added ' + this.registerForm.value.firstname,
        )
        this.submitted = false
        this.registerForm.reset()
      }
    })
  }
  returnprev() {
    this.location.back()
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}
